import  React, { createContext, useCallback, useState, useContext } from 'react';
import api from '../services/api';

export interface User {
  id: string;
  name: string;
  email: string;
  progress: number;
  isAdmin: boolean;
  created_at: Date;
}

export interface Admin {
  id: string;
  name: string;
  email: string;
}

interface AuthState {
  token: string;
  user: User;
};

interface SignInCredentials {
  email: string;
  password: string;
}

interface AuthContextData {
  user: User;
  signIn(credentials: SignInCredentials): Promise<void>;
  signOut(): void;
};

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

export const AuthProvider: React.FC = ({ children }) => {
  const [ data, setData ] = useState<AuthState>(() => {
    const token = localStorage.getItem('@ThermoSym:token');
    const user = localStorage.getItem('@ThermoSym:user');

    if (token && user) {
      api.defaults.headers.authorization = `Bearer ${token}`;
      return { token, user: JSON.parse(user) };
    }

    return {} as AuthState;
  });

  const signIn = useCallback(async ({ email, password }) => {
    try {
      const response = await api.post('sessions', {
        email,
        password
      });
  
      const { token, user } = response.data;
  
      localStorage.setItem('@ThermoSym:token', token);
      localStorage.setItem('@ThermoSym:user', JSON.stringify(user));
  
      api.defaults.headers.authorization = `Bearer ${token}`;
  
      setData({ token, user });      
    } catch (err) {
      throw new Error('Você não tem autorização para acessar este site.');
    }
  }, []);

  const signOut = useCallback(() => {
    localStorage.removeItem('@ThermoSym:token');
    localStorage.removeItem('@ThermoSym:user');

    setData({} as AuthState);
  }, []);

  return (
    <AuthContext.Provider value={{ user: data.user, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  )
};

export function useAuth(): AuthContextData {
  const context = useContext(AuthContext);

  return context;
}